import { Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';

import { PlaceholderCard } from './PlaceholderCard';
import { useDocumentTitle } from './useDocumentTitle';

/** Parents that render this component pass the same title to their own `useDocumentTitle`, since theirs runs last. */
export const NO_ACCESS_TITLE = 'No access';

/** Shown instead of a silent redirect when the GT hub is not available to this user. */
export function GroundTruthNoAccess() {
    useDocumentTitle(NO_ACCESS_TITLE);
    return (
        <main className="flex h-screen items-center justify-center bg-white">
            <PlaceholderCard
                className="rounded-md border border-dashed bg-white p-8 text-center"
                data-testid="GroundTruthNoAccess"
                title="You don’t have access to Ground Truth."
                titleClassName="text-sm font-medium text-gray-900"
                description="Ground Truth isn’t enabled for your account or this environment. Ask an administrator if you need it."
                descriptionClassName="mt-1 text-sm text-muted-foreground"
            >
                <Button asChild variant="outline" size="sm" className="mt-4">
                    <Link to="/">Go to home</Link>
                </Button>
            </PlaceholderCard>
        </main>
    );
}
